import i18next from 'i18next'

// Import all language files
import ar from '../data/ar/strings.json'
import da from '../data/da/strings.json'
import de from '../data/de/strings.json'
import el from '../data/el/strings.json'
import en from '../data/en/strings.json'
import es from '../data/es/strings.json'
import fi from '../data/fi/strings.json'
import fr from '../data/fr/strings.json'
import he from '../data/he/strings.json'
import hu from '../data/hu/strings.json'
import it from '../data/it/strings.json'
import ja from '../data/ja/strings.json'
import ko from '../data/ko/strings.json'
import nb from '../data/nb/strings.json'
import nl from '../data/nl/strings.json'
import pl from '../data/pl/strings.json'
import pt from '../data/pt/strings.json'
import ro from '../data/ro/strings.json'
import ru from '../data/ru/strings.json'
import sv from '../data/sv/strings.json'
import tr from '../data/tr/strings.json'
import zh from '../data/zh/strings.json'

// Import menu-labels files
import arMenuLabels from '../data/ar/menu-labels.json'
import daMenuLabels from '../data/da/menu-labels.json'
import deMenuLabels from '../data/de/menu-labels.json'
import elMenuLabels from '../data/el/menu-labels.json'
import enMenuLabels from '../data/en/menu-labels.json'
import esMenuLabels from '../data/es/menu-labels.json'
import fiMenuLabels from '../data/fi/menu-labels.json'
import frMenuLabels from '../data/fr/menu-labels.json'
import heMenuLabels from '../data/he/menu-labels.json'
import huMenuLabels from '../data/hu/menu-labels.json'
import itMenuLabels from '../data/it/menu-labels.json'
import jaMenuLabels from '../data/ja/menu-labels.json'
import koMenuLabels from '../data/ko/menu-labels.json'
import nbMenuLabels from '../data/nb/menu-labels.json'
import nlMenuLabels from '../data/nl/menu-labels.json'
import plMenuLabels from '../data/pl/menu-labels.json'
import ptMenuLabels from '../data/pt/menu-labels.json'
import roMenuLabels from '../data/ro/menu-labels.json'
import ruMenuLabels from '../data/ru/menu-labels.json'
import svMenuLabels from '../data/sv/menu-labels.json'
import trMenuLabels from '../data/tr/menu-labels.json'
import zhMenuLabels from '../data/zh/menu-labels.json'

const setupLangObserver = () => {
  // Create an observer instance
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'lang') {
        const htmlLang = document.documentElement.lang
        const mainLang = htmlLang.split('-')[0]
        i18next.changeLanguage(mainLang)
      }
    })
  })

  // Start observing the document with the configured parameters
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['lang']
  })

  return observer
}

export const init = () => {
    // Get language from HTML lang attribute or default to 'it'
    const htmlLang = document.documentElement.lang || 'it'
    // Extract main language code (e.g., 'en-US' -> 'en', 'it-IT' -> 'it')
    const mainLang = htmlLang.split('-')[0]
    
    // Initialize i18next with all language resources
    i18next
        .init({
            lng: mainLang, // use main language code from HTML tag
            fallbackLng: 'en',
            debug: false, // enable debug mode
            resources: {
                ar: { translation: { ...ar, ...arMenuLabels } },
                da: { translation: { ...da, ...daMenuLabels } },
                de: { translation: { ...de, ...deMenuLabels } },
                el: { translation: { ...el, ...elMenuLabels } },
                en: { translation: { ...en, ...enMenuLabels } },
                es: { translation: { ...es, ...esMenuLabels } },
                fi: { translation: { ...fi, ...fiMenuLabels } },
                fr: { translation: { ...fr, ...frMenuLabels } },
                he: { translation: { ...he, ...heMenuLabels } },
                hu: { translation: { ...hu, ...huMenuLabels } },
                it: { translation: { ...it, ...itMenuLabels } },
                ja: { translation: { ...ja, ...jaMenuLabels } },
                ko: { translation: { ...ko, ...koMenuLabels } },
                nb: { translation: { ...nb, ...nbMenuLabels } },
                nl: { translation: { ...nl, ...nlMenuLabels } },
                pl: { translation: { ...pl, ...plMenuLabels } },
                pt: { translation: { ...pt, ...ptMenuLabels } },
                ro: { translation: { ...ro, ...roMenuLabels } },
                ru: { translation: { ...ru, ...ruMenuLabels } },
                sv: { translation: { ...sv, ...svMenuLabels } },
                tr: { translation: { ...tr, ...trMenuLabels } },
                zh: { translation: { ...zh, ...zhMenuLabels } }
            },
            interpolation: {
                escapeValue: false // react already safes from xss
            }
        })
        .then(() => {
            // Setup the observer after i18next is initialized
            setupLangObserver()
        })
        .catch(error => {
            console.error('Error initializing i18next:', error)
        })
}

export default init
